import { useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { colors, spacing, Text, useLayoutDimensions } from '@pletly/ui';
import { useToggle } from '%hooks';

const VISIBLE_LINES = 4;
const SINGLE_LINE_HEIGHT = 28;

export const AboutText = ({ text }: { text: string }) => {
	const { t } = useTranslation();
	const [expanded, toggleExpansion] = useToggle();
	const [showExpandButton, setShowExpandButton] = useState(false);
	const { width: layoutWidth, onLayout } = useLayoutDimensions();

	const toggleButtonText = useMemo(
		() => (!expanded ? t('common.read-more') : t('common.show-less')),
		[expanded, t],
	);

	return (
		<>
			<View style={styles.root} onLayout={onLayout}>
				<Text
					numberOfLines={!expanded ? VISIBLE_LINES : undefined}
					ellipsizeMode="tail"
					style={styles.aboutText}
				>
					{text}
				</Text>
				{showExpandButton ? <Text onPress={toggleExpansion}>{toggleButtonText}</Text> : null}
			</View>
			<Text
				style={[styles.aboutText, styles.measurementText, { width: layoutWidth }]}
				onLayout={(event) => {
					const { height } = event.nativeEvent.layout;
					setShowExpandButton(height > VISIBLE_LINES * SINGLE_LINE_HEIGHT);
				}}
			>
				{text}
			</Text>
		</>
	);
};

const styles = StyleSheet.create({
	root: {
		alignItems: 'flex-start',
		marginTop: spacing(),
	},
	aboutText: {
		color: colors.primary500,
		lineHeight: SINGLE_LINE_HEIGHT,
	},
	measurementText: {
		//@ts-expect-error not in types, but working on web
		position: 'fixed',
		bottom: -1000,
		color: colors.transparent,
	},
});
